module.exports = "/_next/static/media/onboard-4-extension.66290695.webm";